import Footer from '../components/Footer';
import './Marketing.css';

const AssistantPage = () => {
  return (
    <>
      <div className="landing-shell assistant-page-shell">
        <div className="landing-pattern" />
        <div className="landing-noise" />
        <div className="landing-bubbles" aria-hidden="true">
          <span className="bubble b1" />
          <span className="bubble b2" />
          <span className="bubble b3" />
          <span className="bubble b4" />
          <span className="bubble b5" />
          <span className="bubble b6" />
          <span className="bubble b7" />
          <span className="bubble b8" />
        </div>

        <div className="hero animate-fade">
          <div className="hero-copy">
            <span className="pill glow">Servantica AI Assistant</span>
            <h1 className="animate-up">Hands-free voice help that starts with your wake word</h1>
            <p className="animate-up delay-1">
              Servantica AI Assistant is designed for voice-first use. Say your wake word, start the assistant instantly,
              and ask it to open SMS, calls, files, notifications, or AI tools without hunting through menus.
            </p>
            <div className="hero-cta animate-up delay-2">
              <a className="assistant-launch-btn" href="/login?returnTo=/dashboard" aria-label="Open the Servantica voice-enabled workspace">
                <span className="assistant-launch-pulse" aria-hidden="true">
                  <span />
                  <span />
                </span>
                <span className="assistant-launch-copy">
                  <strong>Open voice-enabled workspace</strong>
                  <small>Continue to your Servantica dashboard assistant flow</small>
                </span>
                <span className="assistant-launch-arrow" aria-hidden="true">→</span>
              </a>
            </div>
            <div className="hero-meta animate-up delay-3">
              <span>Wake-word activation</span>
              <span>Hands-free task routing</span>
              <span>Voice-first Servantica controls</span>
            </div>
            <div className="voice-benefits animate-up delay-3" aria-label="Assistant capabilities">
              <div className="voice-benefit">
                <span className="voice-benefit-icon" aria-hidden="true">🗣️</span>
                <div>
                  <strong>Start by speaking</strong>
                  <p>Use your wake word to bring up the assistant naturally instead of tapping extra buttons.</p>
                </div>
              </div>
              <div className="voice-benefit">
                <span className="voice-benefit-icon" aria-hidden="true">🧭</span>
                <div>
                  <strong>Route to the right tool</strong>
                  <p>Ask for SMS, calls, or AI actions and Servantica guides you to the right workspace instantly.</p>
                </div>
              </div>
              <div className="voice-benefit">
                <span className="voice-benefit-icon" aria-hidden="true">✨</span>
                <div>
                  <strong>Stay focused</strong>
                  <p>One assistant entry point keeps the experience calm, accessible, and easy to start.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="hero-panel animate-up delay-1">
            <div className="glass-card assistant-signal-card">
              <div className="card-head">
                <div>
                  <p className="label">Voice flow</p>
                  <h3>From wake word to action</h3>
                </div>
                <span className="tag success">Live</span>
              </div>
              <div className="signal-wave" aria-hidden="true">
                <span />
                <span />
                <span />
                <div className="signal-core">🎙️</div>
              </div>
              <ul className="assistant-flow">
                <li>
                  <span className="assistant-step">1</span>
                  <div>
                    <strong>Say the wake word</strong>
                    <p>Activate Servantica AI Assistant without touching the screen.</p>
                  </div>
                </li>
                <li>
                  <span className="assistant-step">2</span>
                  <div>
                    <strong>Speak your task</strong>
                    <p>Ask for SMS, outbound calls, file actions, or AI workflows in plain language.</p>
                  </div>
                </li>
                <li>
                  <span className="assistant-step">3</span>
                  <div>
                    <strong>Let Servantica route you</strong>
                    <p>Open the right surface quickly with a guided, voice-first experience.</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default AssistantPage;
